import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './components/header/header.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { PopoverTextComponent } from './components/popover-text/popover-text.component';
import { ExportPdfComponent } from './components/export-pdf/export-pdf.component';
import { TableComponent } from './components/export-pdf/table/table.component';
import { HeaderLayoutComponent } from './components/header-detail/header.component';
import { TesteComponentComponent } from './components/teste-component/teste-component.component';
import { PopoverSelectColorComponent } from './components/popover-select-color/popover-select-color.component';
import { BlockSectorComponent } from './components/block-sector/block-sector.component';
import { ScaleChangeRequestItemComponent } from './components/scale-change-request-item/scale-change-request-item.component';
import { ScaleChangeRequestCardComponent } from './components/scale-change-request-card/scale-change-request-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  exports: [
    HeaderComponent,
    CheckboxComponent,
    PopoverTextComponent,
    ExportPdfComponent,
    HeaderLayoutComponent,
    TesteComponentComponent,
    PopoverSelectColorComponent,
    BlockSectorComponent,
    ScaleChangeRequestItemComponent,
    ScaleChangeRequestCardComponent
  ],
  declarations: [
    HeaderComponent,
    CheckboxComponent,
    PopoverTextComponent,
    ExportPdfComponent,
    TableComponent,
    HeaderLayoutComponent,
    TesteComponentComponent,
    PopoverSelectColorComponent,
    BlockSectorComponent,
    ScaleChangeRequestItemComponent,
    ScaleChangeRequestCardComponent
  ]
})
export class SharedPageModule {}
